import { IOption } from '@utils/interfaces';

export const personTypeOptions: IOption[] = [
  { value: 'PF', label: 'Pessoa física' },
  { value: 'PJ', label: 'Pessoa jurídica' },
];
